import { Box, Stack, Typography } from '@mui/material'
import { memo } from 'react'
import { blueFull, greenFull, redFull } from '../../pages/home/plChart'
import { callColorCumulative, putColorCumulative } from '../multiStikeChart/styles'

const PayoffLegends = () => {
    return (
        <Stack spacing={1} direction={'row'} alignItems={'center'}>
            <Stack spacing={1} direction={'column'} alignItems={'start'}>
                <Stack spacing={1} direction={'row'} alignItems={'center'}>
                    <Box style={{ width: '20px', borderRadius: '2px', height: '4px', background: `linear-gradient( 90deg,${greenFull} 50%, ${redFull} 50% )` }} />
                    <Typography fontSize={10} color={'text.secondary'}>
                        ON EXPIRY
                    </Typography>
                </Stack>
                <Stack spacing={1} direction={'row'} alignItems={'center'}>
                    <Box style={{ width: '20px', borderRadius: '2px', height: '4px', background: blueFull }} />
                    <Typography fontSize={10} color={'text.secondary'}>
                        ON TARGET DAY
                    </Typography>
                </Stack>
            </Stack>
            <Stack spacing={1} direction={'column'} alignItems={'center'}>
                <Stack spacing={1} direction={'row'} alignItems={'center'}>
                    <Box style={{ marginLeft: '8px', background: callColorCumulative, borderRadius: '2px', height: '16px', width: '4px' }} />
                    <Typography fontSize={10} color={'text.secondary'}>
                        CE OI
                    </Typography>
                </Stack>
                <Stack spacing={1} direction={'row'} alignItems={'center'}>
                    <Box style={{ marginLeft: '8px', background: putColorCumulative, borderRadius: '2px', height: '16px', width: '4px' }} />
                    <Typography fontSize={10} color={'text.secondary'}>
                        PE OI
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default memo(PayoffLegends)
